import { useIfaStore } from '@ifa/store';
import Alert from '@mui/material/Alert';

type DashboardTableStateHandlerProps = {
    children: React.ReactNode;
};

function DashboardTableStateHandler({ children }: DashboardTableStateHandlerProps) {
    const appStatus = useIfaStore(state => state.app.status);
    const firstLoad = useIfaStore(state => state.table.firstLoad);
    const appError = useIfaStore(state => state.app.error) as Error;
    const isEmpty = useIfaStore(state => state.table.isEmpty);

    if (appStatus === 'error') {
        return (
            <Alert severity="error" data-cy="state-error">
                {appError?.message ?? 'An error occurred while fetching data.'}
            </Alert>
        );
    }

    if (firstLoad) {
        return (
            <Alert severity="info" data-cy="state-loading">
                Loading...
            </Alert>
        );
    }

    if (isEmpty && appStatus !== 'fetching') {
        return (
            <Alert severity="warning" data-cy="state-empty">
                No forms currently exist for your transplant center(s). Please submit a request via{' '}
                <b>Create form request</b> button above.
            </Alert>
        );
    }

    return children;
}

export default DashboardTableStateHandler;
